// What the app remembers between opens, so that opening it shows what was
// there at once and the server's answers only bring it up to date: who is
// signed in, and the queue Train last had. Kept in this browser only, and
// forgotten on signing out.

const PREFIX = "blundermine.kept.";

export function kept<T>(name: string): T | null {
  try {
    const text = localStorage.getItem(PREFIX + name);
    return text ? (JSON.parse(text) as T) : null;
  } catch {
    return null;
  }
}

export function keep(name: string, value: unknown): void {
  try {
    localStorage.setItem(PREFIX + name, JSON.stringify(value));
  } catch {
    // Full, or a private window: the next open waits for the server.
  }
}

export function forgetAll(): void {
  try {
    for (const key of Object.keys(localStorage)) if (key.startsWith(PREFIX)) localStorage.removeItem(key);
  } catch {
    // Nothing kept.
  }
}

/** Sign out, and forget what was kept for whoever was signed in. */
export async function signOut(): Promise<void> {
  forgetAll();
  await fetch("/api/logout", { method: "POST" });
  location.reload();
}
